import { eventDetails } from "../data/content";
import WeddingHeaderStatus from "../components/WeddingHeaderStatus";
import "./Footer.css";

export default function Footer(): JSX.Element {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>
          <strong>Fanni &amp; Marci</strong>
          <p>
            {eventDetails.date} · {eventDetails.time} · {eventDetails.region}
          </p>
        </div>
        <div className="footer__links">
          <a href="/#schedule">Program</a>
          <a href="/#ceremony-master">Ceremóniamester</a>
          <a href="/#travel">Helyszínek</a>
          <a href={eventDetails.rsvpPath}>Visszajelzés</a>
        </div>
        <WeddingHeaderStatus />
      </div>
    </footer>
  );
}
